import UUID from 'app/src/data/base/UUID';
import Payment from 'app/src/payments/Payment';
/**
 * Class definition of a pending payment.  Pending payments aren't submitted until
 * a sale is completed.
 */
export default class PendingPayment extends Payment {
  /**
   * Constructor
   *
   * @param amount {Number}   The amount of the payment
   * @param paymentTypeID {Number}    The ID of the payment type
   * @param {string|null}  remoteReference The remote reference to use for the payment; if not specified one will
   *                                  be generated
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount, paymentTypeID = 0, remoteReference = null, saleID = 0) {
    super(amount, paymentTypeID, saleID);

    this._commitImmediately = false;
    this._transactionReferenceID = null;

    // Generate a remote reference for tracking the payment.  This is used to identify the payment
    // even if it doesn't have a API-generated key yet.
    this.model.set('remoteReference', remoteReference || UUID.generate());
  }

  /**
   * Setter for the transactionReferenceID for the Pending Payment.  This is a special parameter
   * set for iZettle payments.
   *
   * @param transactionReferenceID {null|*|string}   The transaction reference ID
   */
  set transactionReferenceID(transactionReferenceID) {
    this._transactionReferenceID = transactionReferenceID;
  }

  /**
   * Getter for the transactionRefrenceID set for the Pending Payment.  This is a special parameter
   * set for iZettle payments.
   *
   * @returns {null|*|string} The transaction reference ID
   */
  get transactionReferenceID() {
    return this._transactionReferenceID;
  }

  /**
   * Clones the Pending payment
   *
   * @returns {Payment}   The cloned payment
   */
  clone() {
    let clone = super.clone();

    clone.transactionReferenceID = this.transactionReferenceID;

    return clone;
  }
}
